import React, {useState} from 'react'
import moment from 'moment'
import './SegmentContactMobileCard.scss'
import { Contact, ContactGroupMap } from '../../../../../services/cellcast.v2.types'
import { getValueByFields } from '../../../../Utils/getValueByFields'

interface SegmentContactMobileCardProps {
  contact: ContactGroupMap
  isSelected: boolean
  onSelect: (id: string) => void
  dbOptions?: string[]
}

export const SegmentContactMobileCard: React.FC<SegmentContactMobileCardProps> = ({
  contact,
  isSelected,
  onSelect,
  dbOptions = [],
}) => {
  const [showDetails, setShowDetails] = useState(false)
  const getCustomFields = () => {
    if (!dbOptions || dbOptions.length === 0) return []
    return dbOptions.filter(
      (field) => !['First Name', 'Full Name', 'Last Name'].includes(field)
    )
  }

  const tags = contact?.tags?.filter((data: any) => {
    if (data?.type) {
      return data?.isHidden !== false && data?.type !== 'list'
    }
    return data?.isHidden !== false
  })

  const firstName = getValueByFields(contact, 'First Name')
  const lastName = getValueByFields(contact, 'Last Name')
  const fullName = getValueByFields(contact, 'Full Name')
  const displayName = fullName !== '-' ? fullName : `${firstName} ${lastName}`.trim() || contact?.number || 'N/A'

  return (
    <div className={`segment-contact-mobile-card ${isSelected ? 'selected' : ''}`}>
      {/* Header with checkbox, name/number, and expand button */}
      <div className='card-header-section'>
        <div className='d-flex align-items-center gap-3 flex-grow-1'>
          <input
            type='checkbox'
            className='form-check-input contact-checkbox'
            checked={isSelected}
            onChange={() => onSelect(contact._id)}
            aria-label={`Select ${displayName}`}
          />
          <div className='contact-info-section flex-grow-1'>
            <h5 className='contact-name'>{displayName}</h5>
            {contact?.number && (
              <div className='contact-number text-muted small'>
                <i className='fas fa-phone me-1'></i>
                {contact.number}
              </div>
            )}
          </div>
        </div>
        <button
          className='btn btn-action-mobile'
          onClick={() => setShowDetails(!showDetails)}
          aria-label={showDetails ? 'Hide details' : 'Show details'}
          aria-expanded={showDetails}
        >
          <i className={`bi bi-chevron-${showDetails ? 'up' : 'down'}`}></i>
        </button>
      </div>

      {/* Tags */}
      {tags && tags.length > 0 && (
        <div className='card-tags-section mb-3'>
          <div className='d-flex flex-wrap gap-2'>
            {tags.map((tag: {_id: string; name: string; color: string}, i: number) => (
              <span
                key={i}
                className='inbox-tags'
                style={{
                  color: tag?.color ? 'white' : 'black',
                  backgroundColor: tag?.color ? tag.color : '',
                }}
              >
                {tag?.name}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Expandable details */}
      {showDetails && (
        <div className='card-details-section'>
          <div className='card-details-grid'>
            {/* Date Added */}
            {contact?.createdAt && (
              <div className='detail-item'>
                <span className='detail-label'>
                  <i className='fas fa-calendar-plus me-1'></i>
                  Date Added
                </span>
                <span className='detail-value'>
                  {moment(contact.createdAt).format('DD/MM/YYYY')}
                </span>
              </div>
            )}

            {/* First Name */}
            {dbOptions?.includes('First Name') && (
              <div className='detail-item'>
                <span className='detail-label'>
                  <i className='fas fa-user me-1'></i>
                  First Name
                </span>
                <span className='detail-value'>{firstName}</span>
              </div>
            )}

            {/* Last Name */}
            {dbOptions?.includes('Last Name') && (
              <div className='detail-item'>
                <span className='detail-label'>
                  <i className='fas fa-user me-1'></i>
                  Last Name
                </span>
                <span className='detail-value'>{lastName}</span>
              </div>
            )}

            {/* Full Name */}
            {dbOptions?.includes('Full Name') && (
              <div className='detail-item'>
                <span className='detail-label'>
                  <i className='fas fa-user me-1'></i>
                  Full Name
                </span>
                <span className='detail-value'>{fullName}</span>
              </div>
            )}

            {/* Custom Fields */}
            {getCustomFields().map((fieldName: string, i: number) => {
              const fieldValue = getValueByFields(contact, fieldName)
              const isBirthday = fieldName === 'Birthday'
              const displayValue = isBirthday && fieldValue !== '-'
                ? moment(fieldValue).format('DD/MM/YYYY')
                : fieldValue

              return (
                <div key={i} className='detail-item'>
                  <span className='detail-label'>
                    <i className='fas fa-tag me-1'></i>
                    {fieldName}
                  </span>
                  <span className='detail-value'>{displayValue}</span>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

